import request from '@/utils/request'

let Route_batchApi = {

  /*路线批次列表*/
  list(data) {
    return request._post('/shop/plus.route_batch.Index/index', data);
},
/*添加路线批次*/
add(data) {
    return request._post('/shop/plus.route_batch.Index/add', data);
},
/*修改路线批次*/
edit(data) {
    return request._post('/shop/plus.route_batch.Index/edit', data);
},
/*删除路线批次*/
del(data) {
    return request._post('/shop/plus.route_batch.Index/del', data);
},
/*路线批次详情*/
detail(data) {
  return request._post('/shop/plus.route_batch.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.route_batch.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.route_batch.Setting/getSetting', data, errorback);
    },
}
export default Route_batchApi;



// WEBPACK FOOTER //
// ./src/api/route_batch.js